import { render, staticRenderFns } from "./TabXMLPreview.view.vue?vue&type=template&id=31b56902&"
import script from "./TabXMLPreview.view.vue?vue&type=script&lang=js&"
export * from "./TabXMLPreview.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31b56902')) {
      api.createRecord('31b56902', component.options)
    } else {
      api.reload('31b56902', component.options)
    }
    module.hot.accept("./TabXMLPreview.view.vue?vue&type=template&id=31b56902&", function () {
      api.rerender('31b56902', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/common/partials/TabXMLPreview.view.vue"
export default component.exports